// stores/authStore.js
import { createSlice, configureStore } from '@reduxjs/toolkit';

// Define the initial state
const initialState = {
  loggedIn: false,
  username: '',
};

// Create a slice for auth-related actions
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.loggedIn = true;
      state.username = action.payload.username;
    },
    logoutSuccess: (state) => {
      state.loggedIn = false;
      state.username = '';
    },
    setCustomerId: (state, action) => {
      state.customerId = action.payload; 
    },
  },
});

export const { loginSuccess, logoutSuccess, setCustomerId  } = authSlice.actions;

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
  },
});

export default store;
